import { render } from "./AddOuvFermPage.vue?vue&type=template&id=5ec31054&ts=true"
import script from "./AddOuvFermPage.vue?vue&type=script&lang=ts"
export * from "./AddOuvFermPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__